<template>
  <section v-if="lang.vcc">
    <Title :title-name="lang.vcc.SFS_LANG_ROW_7" :title-link="title.VirtualCreditCardDetail.titleLink" />
    <div class="container" style="margin-top: 14pt">
      <div>
        <p>{{ lang.vcc.SFS_LANG_ROW_2 }}</p>
        <CreditCard></CreditCard>
        <p>{{ lang.vcc.SFS_LANG_ROW_3 }}</p>
        <p>{{ lang.vcc.SFS_LANG_ROW_4 }}</p>
        <p>{{ lang.vcc.SFS_LANG_ROW_5 }}</p>
        <p
          v-html="
            replaceStr(
              lang.vcc.SFS_LANG_ROW_6,
              ['<amount>', '<currency>'],
              [VirtualCreditCardDetail.price_per_person, newcurrency]
            )
          "
        ></p>
      </div>
    </div>
  </section>
</template>

<script>
import CreditCard from '@/components/CreditCard/index'
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import Title from '@/components/Title/index'

export default {
  name: 'VirtualCreditCardDetail',
  components: { CreditCard, Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageTitle: 'Virtual Creditcards',
      newcurrency: ''
    }
  },
  computed: {
    ...mapGetters({
      VirtualCreditCardDetail: 'VirtualCreditCardDetail/VirtualCreditCardDetail'
    })
  },
  watch: {
    VirtualCreditCardDetail: function (newVal) {
      this.newcurrency = newVal.currency.toUpperCase()
    }
  },
  created() {
    this.$store.dispatch('VirtualCreditCardDetail/getVirtualCreditCardDetail')
  },
  methods: {
    replaceStr
  }
}
</script>
